import styled from 'styled-components'
import { Scrollbars } from 'react-custom-scrollbars'
import { notification } from 'antd'

interface PageContainerProps {
  children: JSX.Element | JSX.Element[] | string
  crumbs?: JSX.Element | JSX.Element[] | string
  contentStyle?: React.CSSProperties
  style?: React.CSSProperties
}

export const PageContainer = (props: PageContainerProps) => {
  const { children, crumbs = null, contentStyle, style = {} } = props
  return (
    <PageContainerBox
      onClick={() => {
        notification.destroy()
      }}
      style={style}
    >
      {crumbs !== null && <CrumbsContainer>{crumbs}</CrumbsContainer>}
      <Content style={contentStyle}>{children}</Content>
    </PageContainerBox>
  )
}
const PageContainerBox = styled.div`
  height: calc(100% + 10px);

  background: #f1f3f5;
  display: flex;
  flex-direction: column;
  .delete {
    &:hover {
      border-color: red;
      color: red;
    }
  }
`
const Content = styled.div`
  display: flex;
  min-height: calc(100% - 32px);
  margin: 16px;
  border-radius: 8px;
  overflow-y: scroll;
`
const PageScrollbars = styled(Scrollbars)`
  background-color: #f1f3f5;
  position: static !important;
`
const CrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 16px 16px 0 16px;
`
